import { makeRequest } from "../http-common";

const PolicyDataService = {

  async search(term) {
    return makeRequest("get", `/policy/search/${term}`);
  },

  async getPaymentsByRef(ref) {
    return makeRequest("get", `/policy/${ref}/payments`);
  },

  async getPaymentsByStatus() {
    return makeRequest("get", "/policy/all");
  },


  async getById(id) {
    return makeRequest("get", `/policy/${id}`);
  },

  async getByStatus(status) {
    return makeRequest("get", `/policy/status/${status}`);
  },

  async getAll() {
    return makeRequest("get", "/policy/all");
  },

  async getAspects(ref) {
    return makeRequest("get", `/policy/${ref}/aspects`);
  },

  async getPayments(ref) {
    return makeRequest("get", `/policy/${ref}/payments`);
  },

  async storePayment(ref, data) {
    return makeRequest("post", `/policy/${ref}/payment`, data);
  },

  async getCommissions(ref) {
    return makeRequest("get", `/policy/${ref}/commissions`);
  },

  async update(id, data) {
    return makeRequest("put", `/policy/${id}`, data);
  },

  async unlink(relationship_id) {
    return makeRequest("delete", `/policy/relationship/${relationship_id}`);
  },

  async linkToAspect(policyId, aspectId, relationship) {
    return makeRequest("post", `/policy/${policyId}/relate/${aspectId}`, { relationship });
  },

  async create(form_data) {
    console.log('API called?');
    const raw = form_data;
    const final = Object.fromEntries(
      Object.entries(raw).map(([key, val]) => [key, val || null]),
    );
    return makeRequest("post", "/policy/create", final);
  },

  async renew(id, data) {
    return makeRequest("post", `/policy/${id}/renew`, data);
  },
};

export default PolicyDataService;